import * as React from 'react';
export var datepickerContextDefaultValue = {
  focusedDate: null,
  isDateFocused: function isDateFocused() {
    return false;
  },
  isDateSelected: function isDateSelected() {
    return false;
  },
  isDateHovered: function isDateHovered() {
    return false;
  },
  isDateBlocked: function isDateBlocked() {
    return false;
  },
  isFirstOrLastSelectedDate: function isFirstOrLastSelectedDate() {
    return false;
  },
  onDateFocus: function onDateFocus() {},
  onDateHover: function onDateHover() {},
  onDateSelect: function onDateSelect() {},
  startDate: null,
  endDate: null,
  goToPreviousMonths: function goToPreviousMonths() {},
  goToNextMonths: function goToNextMonths() {}
};
export var DatePickerContext = React.createContext(datepickerContextDefaultValue);